import {alwaysDefinedArray} from './always_array'

const INDEX_BUILD_FACTOR = 40

// We decide up front whether to build an index. Linear scans are cheap for small
// batches, but repeated scans get expensive as either side grows. The estimate
// includes the original oldItems scan work plus the extra growth when new items
// are appended and later scans have to walk past them too.
export function findAndReplace({oldItems = [], newItems = [], iden = 'id', merge} = {}) {
	newItems = alwaysDefinedArray(newItems)
	if (newItems.length === 0) return oldItems

	const items = oldItems.slice()
	const usesIndex = shouldUseIndex(oldItems.length, newItems.length)
	const itemIndexes = usesIndex ? buildItemIndexes(items, iden) : null

	for (let index = 0; index < newItems.length; index += 1) {
		const newItem = newItems[index]
		const existingIndex = itemIndexes ? getItemIndex(itemIndexes, newItem[iden]) : findItemIndexLinear(items, newItem[iden], iden)

		if (existingIndex === -1) {
			if (itemIndexes) itemIndexes.set(newItem[iden], items.length)
			items.push(newItem)
			continue
		}

		const oldItem = items[existingIndex]
		const combinedItem = mergeItems({oldItem, newItem, merge})
		items[existingIndex] = combinedItem
	}

	return items
}

function shouldUseIndex(oldItemsCount, newItemsCount) {
	const estimatedLinearScans = oldItemsCount * newItemsCount + (newItemsCount * (newItemsCount - 1)) / 2
	const estimatedIndexCost = oldItemsCount * INDEX_BUILD_FACTOR
	return estimatedLinearScans > estimatedIndexCost
}

function buildItemIndexes(items, iden) {
	const itemIndexes = new Map()

	for (let index = 0; index < items.length; index += 1) {
		const identifier = items[index][iden]
		if (!itemIndexes.has(identifier)) itemIndexes.set(identifier, index)
	}

	return itemIndexes
}

function findItemIndexLinear(items, identifier, iden) {
	for (let index = 0; index < items.length; index += 1) {
		if (items[index][iden] === identifier) return index
	}

	return -1
}

function getItemIndex(itemIndexes, identifier) {
	const index = itemIndexes.get(identifier)
	return index === undefined ? -1 : index
}

function mergeItems({oldItem, newItem, merge}) {
	let combinedItem = {...oldItem, ...newItem}
	if (merge) combinedItem = merge({combined: combinedItem, old: oldItem, newItem})
	return combinedItem
}
